export function ResultTable(props) {
  const { barcodeFormat, barcodeStr, gs1, stacked, composite, elapsed, gs1Datas } = props.data
  const hasResult = !!barcodeFormat // Determine if there's a valid barcode result

  return (
    <>
      <table style={{ width: '100%' }}  >
        <tbody>
          <tr>
            <td className="table-label-cell" style={{ width: '35%' }}>Barcode Format</td>
            <td>{hasResult && barcodeFormat}</td>
          </tr>
          <tr>
            <td className="table-label-cell">Barcode Text</td>
            <td>{hasResult && barcodeStr}</td>
          </tr>
          <tr>
            <td className="table-label-cell">GS1</td>
            <td>{hasResult && gs1 + ''}</td>
          </tr>
          <tr>
            <td className="table-label-cell">Stacked</td>
            <td>{hasResult && stacked + ''}</td>
          </tr>
          <tr>
            <td className="table-label-cell">Composite</td>
            <td>{hasResult && composite + ''}</td>
          </tr>
        </tbody>
      </table>

      {hasResult && (
        <table style={{ width: '100%' }}  >
          <thead>
            <tr>
              <th style={{ width: '50%' }} className="table-label-cell">Label</th>
              <th className="table-label-cell">Value</th>
            </tr>
          </thead>
          <tbody>
            {gs1Datas && gs1Datas.length > 0 && (
              gs1Datas.map((data, index) => (
                <tr key={index}>
                  <td>{data.label || ''}</td>
                  <td>
                    {typeof data.value === 'string' && data.value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/) ?
                      (() => {
                        try {
                          const date = new Date(data.value)
                          return !isNaN(date) ? date.toLocaleDateString() : data.value
                        } catch (e) {
                          return data.value
                        }
                      })() :
                      data.value ?? ''}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </>
  )
}
